<template>
  <div class="container pb-20 pt-60 md:pt-80">
    <!-- Details -->
    <div class="grid grid-cols-1 gap-20 xl:grid-cols-content">
      <!-- Intro -->
      <div class="content-start">
        <h1 class="my-10 text-header1 md:text-desktop-header1">
          {{ page?.data.title }}
        </h1>
        <PrismicRichText
          :field="page?.data.description"
          class="text-large-copy md:text-desktop-large-copy"
        />

        <!-- Blackbaud Form -->
        <div
          v-if="page?.data.form_id"
          :id="`blackbaud-donation-form_${page?.data.form_id}`"
          class="form my-10 flex justify-center py-10"
        />

        <!-- Slices -->
        <SliceZone
          wrapper="main"
          :slices="page?.data.slices ?? []"
          :components="components"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { components } from "~/slices";

const prismic = usePrismic();
const route = useRoute();
const config = useRuntimeConfig();

const { data: page } = useAsyncData("donations", () =>
  prismic.client.getSingle("donations"),
);

useHead({
  // Script from Blackbaud System
  script: [{ src: "https://sky.blackbaudcdn.net/static/donor-form-loader/2/main.js" }],
});

onMounted(() => {
  // @ts-expect-error External Script to run Blauckbaud Forms
  BBDonorFormLoader.newBlackbaudDonationFormZoned("renxt", "p-2EYQBLYezEiFbHY_h8lblw", page.value?.data.form_id, "eur");
});

useSeoMeta({
  description: () => page.value?.data.meta_description?.length ? page.value.data.meta_description : prismic.asText(page.value?.data.description),
  ogTitle: () => page.value?.data.meta_title?.length ? page.value.data.meta_title : page.value?.data.title,
  ogUrl: () => `${config.public.BASE_URL}${route.fullPath}`,
  ogDescription: () => page.value?.data.meta_description?.length ? page.value.data.meta_description : prismic.asText(page.value?.data.description),
  ogImage: () => page.value?.data.meta_image.url?.length ? page.value.data.meta_image.url : `${config.public.BASE_URL}/lightbox_gallery.jpg`,
  ogImageType: () => "image/jpeg",
  ogImageWidth: () => "1200",
  ogImageHeight: () => "630",
  ogType: () => "website",
  twitterTitle: () => page.value?.data.meta_title?.length ? page.value.data.meta_title : page.value?.data.title,
  twitterImage: () => page.value?.data.meta_image.url?.length ? page.value.data.meta_image.url : `${config.public.BASE_URL}/lightbox_gallery.jpg`,
  twitterDescription: () => page.value?.data.meta_description?.length ? page.value.data.meta_description : prismic.asText(page.value?.data.description),
});
</script>

<style lang="scss">
.form iframe {
  background: none !important;
  width: 100% !important;
  max-width: 100% !important;
}

@media (width >= 992px) {
  .form iframe {
    margin-left: -150px !important;
  }
}
</style>
